import { useStore } from "@nanostores/react";
import {
  brandSettings,
  paymentInfo as $paymentInfoAtom,
} from "../../store/nanostore";
import { LoadingSpinner1 } from "../../pages/AddUserPage/AddUser";
import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import OtpField from "../../pages/Otp/OtpField";
import { PayBtn1 } from "./UserInfo";
import { usePlaidLink } from "react-plaid-link";
import { useMutation } from "@apollo/client";
import { MakePlaidTransferPayment } from "../../graphql/mutations/paymentlink";
import environment from "../../env";
import { toast } from "react-toastify";
import { useBankPaymentTokenization } from "../../services/tokenization/useBankPaymentTokenization";
import { constructVisaTinkUrl } from "../../utils/constructVisaTinkUrl";
import { ListUserBankAccount } from "./ListUserBankAccount";
import { useMakePayment } from "../../hooks/useMakePayment";
import { PayWithBank } from "./PayWithBank";

export const PayWithVisaTink = ({ onClose }: any) => {
  const { isLoading, data, bankInfo } = useBankPaymentTokenization("tink");

  const $paymentInfo = useStore($paymentInfoAtom);
  const completedPayment = "";
  const [request, makePayment] = useMakePayment();
  const [selectedAccount, setSelectedAccount] = useState<any>(null);
  const [callFake, setCallFake] = useState<any>(false);

  const handleInitPayment = (payload: any) => {
    makePayment(payload);
    setSelectedAccount(payload.tokenId);
  };
  React.useEffect(() => {
    if (!data?.createTokenization?.code) return;

    const state = JSON.stringify({
      ...$paymentInfo?.payload,
      productPrice: $paymentInfo?.productPrice,
      returnUrl: window.location.href,
      simulator: "test",
    });
    const url = constructVisaTinkUrl(data?.createTokenization?.code, state);
    window.location.href = url;
    // window.open(url);
    // setUrl(url);
  }, [data?.createTokenization?.code]);

  React.useEffect(() => {
    if (!isLoading && data && !callFake) {
      setTimeout(() => {
        setCallFake(true);
      }, 3000);
    }
  }, [isLoading, data]);
  if (isLoading || !data || !callFake) {
    return <LoadingSpinner1 />;
  }
  return (
    <div>
      <PayWithBank />
      {/*<ListUserBankAccount*/}
      {/*  request={request}*/}
      {/*  bankInfo={bankInfo}*/}
      {/*  makePayment={handleInitPayment}*/}
      {/*/>*/}
      {/*{completedPayment && <span>Verifying payments. please wait</span>}*/}
    </div>
  );
};

export const PayWithBankPayment = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  if ($paymentInfo.plaid.existingUser) {
    return <ShowOtpScreenForExistingUser />;
  }
  return <PlaidPaymentNewUser />;
};

export const PlaidPaymentNewUser = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  const $brandSettings = useStore(brandSettings);
  const [loading, setLoading] = useState(false);
  const [plaid, setPlaid] = useState<any>(null);

  const [attemptPlaidTransferPayment, { loading: submittingPlaidPayment }] =
    useMutation(MakePlaidTransferPayment, {
      variables: { ...environment.paymentService },
    });
  const { open, ready } = usePlaidLink({
    token: $paymentInfo.plaid?.link_token,
    onSuccess: (publicToken: any, metadata: any) => {
      setPlaid({ publicToken, metadata });
      setLoading(false);
    },
    onExit(error) {
      setLoading(false);
    },
  });

  const makePayment = async (publicToken: any, metadata: any) => {
    try {
      try {
        await attemptPlaidTransferPayment({
          variables: {
            payload: {
              amount: Number($paymentInfo?.productPrice || 100).toFixed(2),
              publicToken,
              name: $paymentInfo?.payload?.name,
              email: $paymentInfo?.payload?.email,
              phone: $paymentInfo?.payload?.phone,
              account_id: metadata.account_id,
              meta: { ...metadata, ...$paymentInfo?.payload },
            },
          },
        });
        // call backend
        // setPublicToken(public_token);
        // send public_token to server
        setLoading(false);
        window.location.href = `${window.location.origin}/p/${$paymentInfo?.paymentIntent?.reference}/status?method=plaid`;
      } catch (e) {
        toast.error("Could not complete payment");
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (ready && !loading && open) {
      open();
      setLoading(true);
    }
  }, [ready]);

  return !ready ? (
    <CenterLoader />
  ) : (
    <>
      {(loading || submittingPlaidPayment) && <CenterLoader />}
      {!(loading || submittingPlaidPayment) && (
        <ButtonHandler
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          title={plaid ? "Update Bank Account Linking" : "Link Bank Account"}
          onClick={open}
        />
      )}
      <br />
      {plaid && !submittingPlaidPayment && (
        <ButtonHandler
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          title={"Complete Payment"}
          onClick={() => makePayment(plaid?.publicToken, plaid?.metadata)}
        />
      )}
    </>
  );
};

const ShowOtpScreenForExistingUser = () => {
  const $paymentInfo = useStore($paymentInfoAtom);
  const $brandSettings = useStore(brandSettings);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const size = 6;
  const handleOtp = () => {
    setLoading(!loading);
    window.location.href = `${window.location.origin}/p/${$paymentInfo?.paymentIntent?.reference}/status?method=plaid`;
  };

  return (
    <>
      <Content>
        <h4>Enter verification code sent to your email.</h4>
        <OtpField size={size} onChange={setOtp} />
        <PayBtn1
          css={`
            width: 100%;
            margin: 10px 0;
          `}
          backgroundColor={$brandSettings?.primaryColor}
          color={$brandSettings?.secondaryColor}
          onClick={handleOtp as any}
          $active={!loading && otp?.length === size}
        >
          {loading ? "Confirming" : "Verify OTP"}
        </PayBtn1>
      </Content>
    </>
  );
};

const ButtonHandler = ({ title, onClick, backgroundColor, color }: any) => (
  <PayBtn1
    css={`
      width: 100%;
      margin: 10px 0;
      padding: 10px;
    `}
    backgroundColor={backgroundColor}
    color={color}
    onClick={onClick as any}
    $active
  >
    {title || "Link Bank Account"}
  </PayBtn1>
);
export const CenterLoader = () => {
  return (
    <>
      <LoadingSpinner1 small />
    </>
  );
};

const Content = styled.div`
  padding: 20px;
`;
